import { action } from 'satcheljs';

export const viewActivity = action('viewActivity');
